import Model from './BaseModel';
import ParentMarket from '@/Models/ParentMarket.js';

export default class DerivedMarketTemplate extends Model {
	resourceName() {
		return 'derived_market_templates';
	}

	fields() {
		return ['name', 'sport', 'parent_market_id', 'price_matrix'];
	}

	relationships() {
		return {
			parent_market: new ParentMarket()
		};
	}

	getBySportId(sportId) {
		this.queryBuilder.include('parent_market');
		return this.makePersistRequest({
			url: `${this.baseUrl()}/sports/${sportId}/${this.resourceName()}${this.queryBuilder.getQuery()}`,
			method: 'GET'
		}).catch(() => {});
	}

	preparePayload(overrideData = {}) {
		const sortAndReindex = (arr) =>
			arr.sort((a, b) => Number(a.price) - Number(b.price)).map((item, index) => ({ ...item, id: index + 1 }));

		const payload = Object.assign(
			{},
			{
				name: this.name,
				sport_id: this.sport.id,
				parent_market_id: this.parent_market_id,
				price_matrix: this.price_matrix
			},
			overrideData
		);
		payload.price_matrix = sortAndReindex(payload.price_matrix);

		return payload;
	}
}
